import { gql } from '@apollo/client';

export const RELEASE_PACK_MUTATION = gql`
  mutation ReleasePack($data: ReleasePackInput!) {
    releasePack(data: $data)
  }
`;
